var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPieChart03Duotone = function SvgPieChart03Duotone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#9FAFC3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M24 4a20 20 0 0 1 20 20M24 4v20m0-20C12.954 4 4 12.954 4 24s8.954 20 20 20 20-8.954 20-20M24 4c11.046 0 20 8.954 20 20m0 0H24m20 0a20 20 0 0 1-5.817 14.1c-.662.667-.994 1-1.506 1.142a2.2 2.2 0 0 1-1.353-.104c-.484-.219-.806-.661-1.45-1.546L24 24"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F0F8FF",
    stroke: "#516B89",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M44 24a20 20 0 0 1-8.244 16.18L24 24z"
  })));
};
export default SvgPieChart03Duotone;